import { useEffect, useState } from 'react'
import { COUNTDOWN_WINDOW_HOURS } from '../lib/config'

const OFFSET_MS = -3 * 60 * 60 * 1000 // Hora de Argentina (UTC-3)

function pad(value: number): string {
  return String(Math.max(0, value)).padStart(2, '0')
}

/**
 * Deadline determinístico: el próximo múltiplo exacto de la ventana de lanzamiento
 * (por defecto, cada 12 horas en hora de Argentina). Es el mismo para todos los
 * visitantes y no se reinicia por persona.
 */
function getDeadline(windowHours: number): number {
  const windowMs = windowHours * 60 * 60 * 1000
  const now = Date.now() + OFFSET_MS
  const next = Math.ceil(now / windowMs) * windowMs
  return next - OFFSET_MS
}

export function useCountdown(windowHours: number = COUNTDOWN_WINDOW_HOURS) {
  const [remaining, setRemaining] = useState<number>(() =>
    Math.max(0, getDeadline(windowHours) - Date.now()),
  )

  useEffect(() => {
    const tick = () =>
      setRemaining(Math.max(0, getDeadline(windowHours) - Date.now()))
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [windowHours])

  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    isOver: remaining <= 0,
  }
}
